import Radio from './Radio';
export type { RadioProps } from './Radio.types';

export default Radio;
